import React from 'react';
import './SubscriptionCancelledInvoices.scss';
import Loader from '../../common/loader/Loader';

const SubscriptionCancelledInvoiceListItemLoader = () => {
	return (
		<li className="invoices-list-item">
			<section className="invoice">
				<Loader />
			</section>
		</li>
	);
};

export default SubscriptionCancelledInvoiceListItemLoader;
